import { CommonModule } from "@angular/common";
import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";
import { FormControl, ReactiveFormsModule } from "@angular/forms";
import { NgSelectComponent, NgSelectModule } from "@ng-select/ng-select";
import { InputLabelComponent } from "src/components/input-label/input-label.component";
import { DynamicErrorMsgDirective } from "src/directives/dynamic-error-msg.directive";

@Component({
  selector: "app-dropdown-input",
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    NgSelectModule,
    DynamicErrorMsgDirective,
    InputLabelComponent,
  ],
  templateUrl: "./dropdown-input.component.html",
  styleUrls: ["./dropdown-input.component.scss"],
})
export class DropdownInputComponent implements OnInit {
  @Input() appendTo: string = "body";
  @Input() placeholder: string = "";
  @Input() isRequired?: boolean;
  @Input() multiple = false;
  @Input() customSelectedOption = false;
  @Input() markFirst = true;
  @Input() isLoading = false;
  @Input() searchFn?: Function;
  @Input() isOptionWithIcon = false;
  @Input() label!: string;
  @Input() bindLabel!: string;
  @Input() bindValue!: string;
  @Input() bindImageKey?: string;
  @Input() chipKey?: string;
  @Input() list!: { [key: string]: any }[] | string[];
  @Input() noteText: string = "";
  @Input() control!: FormControl;
  @Output() onValueSelect = new EventEmitter<any>();
  @Output() OnRemoveItem = new EventEmitter<any>();
  @Output() onEnterClick = new EventEmitter<any>();
  @Output() onSearch = new EventEmitter<{ term: string; items: any[] }>();

  @ViewChild("ngSelect", { static: false }) ngSelect!: NgSelectComponent;
  isControledValueChanged = false;

  ngOnInit() {
    this.control.valueChanges.subscribe((value) => {
      this.isControledValueChanged = true;
    });
  }

  onSearchChange(event: any) {
    this.isControledValueChanged = false;
    this.onSearch.emit(event);
  }

  onEnterClickEvent(event: Event) {
    event.preventDefault();
    const inputElement = <HTMLInputElement>event.target;
    this.onEnterClick.emit(
      this.isControledValueChanged ? "" : inputElement.value
    );
    inputElement.value = "";
    return false;
  }
}
